import React from 'react';
import classNames from 'classnames';
import { AvatarPlaceholder } from 'components/icons';
import './userPhoto.styles.scss';

export const UserPhoto = ({
	logoUrl,
	logoClass,
	placeholderClass,
	isImage,
}: {
	logoUrl?: string;
	logoClass?: string;
	placeholderClass?: string;
	isImage?: boolean;
}) => {
	const logo = isImage ? (
		<img
			className={classNames('user-photo', logoClass)}
			src={logoUrl}
			alt="User"
		/>
	) : (
		<div
			className={classNames('user-photo', logoClass)}
			style={{ backgroundImage: `url(${logoUrl})` }}
		/>
	);

	return logoUrl ? (
		logo
	) : (
		<AvatarPlaceholder iconClass={classNames('user-photo', placeholderClass)} />
	);
};
